import React, { Component } from 'react';
import styled from 'styled-components'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ObjectId } from 'bson'

import { Button, TextField, Paper, ListTile } from 'components'
import { TagOptions, TagBlock } from 'features'
import { FaEllipsisH, FaCircle } from 'react-icons/fa';

import { randomTagColor } from 'utils'
import * as actionCreators from 'store/actions'
import classes from './TagInput.module.css'
import { Tag } from 'schema'

const defaultStyles = {
    margin: 0
}

const Container = styled.div`
    width: ${props => props.width};
    padding: ${props => props.padding};
    margin: ${props => props.styles.margin};
    background-color: var(--secondary-color);
    display: flex;
    flex-direction: column;
    border-radius: 5px;
`

// const Title = styled.div`
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     margin-bottom: 0.5rem;
//     font-weight: bolder;
//     font-size: 0.9rem;
// `

const Title = styled.div`
    font-weight: bolder;
    font-size: 0.7rem;
    padding: 0.25rem 0 0.5rem 0.25rem;
    text-transform: uppercase;
    color: var(--secondary-accent-color);
`

const Placeholder = styled.div`
    font-size: 0.8rem;
    padding: 0 0.25rem;
    color: ${props => props.error && 'var(--error-color)'};
`

const Icon = styled.div`
    color: ${props => props.color || 'var(--text-color)'};
    display: flex;
    font-size: 0.8rem;
`

class TagInput extends Component {
    constructor(props){
        super(props);
        const {randomColorCode, randomColorName} = randomTagColor(this.props.preferences ? this.props.preferences.theme : 'Dark')
        this.state = {
            content: '',
            color: randomColorName,
            valid: false,
            error: null,
            selectedTags: this.props.item.tags ? Object.values(this.props.item.tags) : [],
            tag: new Tag({color: randomColorCode, pageID: this.props.item['pageID'] || this.props.activePageID, userID: this.props.uid})
        }
        this.updatedStyles = Object.assign({}, defaultStyles, this.props.styles)
        console.log('[TagInput] constructor')
    }

    _getTags = (schema) => {
        let tagBlocks = []
        if(schema === 'page'){
            if(this.props.data){
                const tags = _.filter(this.props.data['tags'], (tag) => (tag['pageID'] === this.props.item['pageID']) || (tag['pageID'] === this.props.activePageID)) || []
                
                if(tags.length > 0){
                    tags.map(tag => {
                        const tagID = tag['tagID']
                        tagBlocks.push(
                            <ListTile onSelect={() => {this.onSelectTag(tagID)}}  placement='bottom'
                                // icon={<TagBlock tag={tag} style={{cursor: 'pointer'}}/>}
                                icon={<FaCircle style={{color: tag['color']}}/>}
                                text={tag['content']}
                                trailingIcon={<Button icon={<FaEllipsisH/>} contextMenu={<TagOptions tag={tag} tagID={tagID}/>} placement='bottom'
                                                styles={{boxShadowColor: 'transparent', color:'var(--secondary-accent-color)', backgroundColor:'transparent', placement:'bottom', hoverColor:'var(--text-color)', margin:0, padding:'0', fontSize:'0.8rem'}}/>}
                                />
                        )
                    })
                } else {
                    tagBlocks.push(<Placeholder error={this.state.error}>{this.state.error || 'No tags created'}</Placeholder>)
                }
            }
        } else if (schema === 'item'){
            Object.values(this.state.selectedTags).map(tagID => {
                const tags = this.props.data['tags']
                const tag = tags[tagID]
                if(tag){ // To filter out tags that got deleted
                    const style = {margin: '0.2rem'}
                    tagBlocks.push(
                        <TagBlock label={tag.content} style={style} tag={tag} onDelete={() => {this.onDeleteTag(tagID)}}/>
                    )
                }
            })
        }
        
        return tagBlocks
    }

    // Textfield handlers
    onSubmitHandler = () => {
        console.log('[TagInput] onSubmitHandler', this.state)
        if(this.state.valid){
            if(ObjectId.isValid(this.props.item['pageID'])){
                this.props.createTag(this.state.tag, this.props.data)
                this.props.onCreate && this.props.onCreate(true)
                this.resetHandler()
            } else {
                console.log('tag creation fail')
                this.props.onCreate && this.props.onCreate(false)
                this.setState({error: 'Please select a page'})
            }
        }
    }

    resetHandler = () => {
        const {randomColorCode, randomColorName} = randomTagColor(this.props.preferences ? this.props.preferences.theme : 'Dark')
        this.setState({
            tag: new Tag({content: '', color: randomColorCode, pageID: this.props.activePageID, userID: this.props.uid}),
            error: null
        })
    }

    onKeyPressHandler = (event) => {
        // console.log(event.charCode, event)
        if (event.charCode === 13) {
            this.onSubmitHandler();
        } 
    }

    onInputHandler = (event) => {
        let updatedTag = {...this.state.tag}
        updatedTag['content'] = event.target.value

        this.setState({
            tag: updatedTag,
            valid: event.target.value.length > 0 ? true : false
        })
    }

    // Tag handlers
    onSelectTag = (tag) => {
        let updatedTags = [...this.state.selectedTags]
        if(!updatedTags.includes(tag)){
            updatedTags.push(tag)
            this.setState({
                selectedTags: updatedTags
            })
            let updatedItem = {...this.props.item}
            updatedItem['tags'] = updatedTags
            this.props.onSelect ? this.props.onSelect(updatedTags) : this.props.updateItem(updatedItem, this.props.data, this.props.uid, this.props.sessionId)
        }
    }

    onDeleteTag = (tag) => {
        let updatedTags = [...this.state.selectedTags]
        const tagIndex = updatedTags.indexOf(tag)
        updatedTags.splice(tagIndex, 1)
        this.setState({
            selectedTags: updatedTags
        })
        let updatedItem = {...this.props.item}
        updatedItem['tags'] = updatedTags
        this.props.onSelect ? this.props.onSelect(updatedTags) : this.props.updateItem(updatedItem, this.props.data, this.props.uid, this.props.sessionId)
    }

    render() {
        const tagBlocks = this._getTags('page')
        const itemTagBlocks = this._getTags('item')
        const content = 
        <Container width={!this.props.inline ? '15rem' : null} padding={!this.props.inline ? '0.5rem' : null} styles={this.updatedStyles}>
            {!this.props.inline ? <Title>Tags</Title> : null}
            <div className={classes.Header}>
                {!this.props.disableTags && itemTagBlocks}
                <TextField type='single' style={{width: '100%'}} size={1} mantainFocus focus
                    value={this.state.tag['content']}
                    onChange={this.onInputHandler} 
                    onKeyPress={this.onKeyPressHandler}/>
            </div>

            <div className={classes.Subtitle}>Select a tag or create one</div>
            <div className={classes.Container}>
                {tagBlocks}
            </div>
        </Container>
        if(this.props.inline){
            return(<div>{content}</div>)
        } else {
            return(<Paper margin='0.5rem 0'>{content}</Paper>)
        }
    }

}

const mapStateToProps = state => {
    return {
        activePageID: state.auth.activePageID,
        uid: state.auth.uid,
        data: state.db.present.data && state.db.present.data.toJS(),
        inputID: state.content.inputID,
        sessionId: state.content.sessionId
    }
};

const mapDispatchToProps = dispatch => {
    return {
        createTag: (tag,data) => dispatch(actionCreators.createTag(tag,data)),
        updateItem: (item, data, uid, sessionId) => dispatch(actionCreators.updateItem(item, data, uid, sessionId)),
        setInput: (inputID) => dispatch(actionCreators.setInput(inputID))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TagInput);

TagInput.propTypes = {
    tags: PropTypes.array
}